import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import InputSelectGame from "../InputSelectGame";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() + 1);

const startDateValue = new Date().toISOString().split("T")[0];
const endDateValue = currentDate.toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function WagersOnGameReport() {
  const [endDate, setEndDate] = useState(endDateValue);

  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback((event) => {
    setStartDate(event.target.value);

    const endDateChanged = new Date(event.target.value);
    endDateChanged.setDate(endDateChanged.getDate() + 1);
    setEndDate(endDateChanged.toISOString().split("T")[0]);
  }, []);

  const [wagerStatus, setWagerStatus] = useState(0);
  const onWagerStatusChanged = useCallback(
    (event) => setWagerStatus(Number(event.target.value)),
    []
  );

  const [higherThan, setHigherThan] = useState("");
  const onHigherThanChanged = useCallback(
    (event) => setHigherThan(event.target.value),
    []
  );

  const [idGame, setIdGame] = useState(0);
  const onGameChanged = useCallback((g) => setIdGame(g), []);

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="Game Date"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Higher Than"
          type="number"
          value={higherThan}
          size="small"
          onChange={onHigherThanChanged}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelectGame
          startDate={startDate}
          endDate={endDate}
          setSelectValue={onGameChanged}
        />
        <div>
          <SubGroup title="Wager Status">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={wagerStatus}
                onChange={onWagerStatusChanged}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Both"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Open"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Graded"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        exportCSV={false}
        groupBy="ticket"
        title="Wagers on Game Report"
        getUrl={() => "/Reports/Report_Wager_On_Game_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          Book: book,
          Office: office,
          HigherThan: higherThan,
          IdGame: idGame,
          WagerStatus: wagerStatus,
        })}
        getGroupOrders={[]}
        getPreProcess={(data) => data.filter(({ idWager }) => idWager > 0)}
        getProcess={(data) => [
          {
            ...data?.[0],
            description: data?.[0]?.completeDescription,
            score: data?.[0]?.loginName,
            phoneIP:
              data?.[0]?.phoneLine !== "-1"
                ? data?.[0]?.phoneLine
                : data?.[0]?.iP,
            resultDetail: data?.[0]?.neto,
            parsedPlacedDate: new Date(data?.[0]?.placedDate),
          },
          ...data.map((item) => ({
            ...item,
            player: "",
            ticket: "",
            placedDate: item.idSport,
            riskAmount: "",
            winAmount: "",
            description: item.detailDescription,
          })),
        ]}
        showTopTotals={true}
        renderTopTotals={({ totals }) => {
          const winLoss = totals.resultDetail ?? 0;
          const risk = totals.riskAmount ?? 0;

          const getColor = (value) => {
            if (value === 0) return "#000";
            return value < 0 ? "#1cd15e" : "#d53636";
          };

          return (
            <div className="flex flex-wrap gap-10 font-bold text-base py-2">
              <div>
                Total Wagers: {totals.totalWagers ?? 0}
              </div>

              <div>
                Total Risk:{" "}
                <span style={{ color: getColor(risk) }}>
                  {decimalInvertedReportFormatter(risk, null, true)}
                </span>
              </div>

              <div>
                Total Win/Loss:{" "}
                <span style={{ color: getColor(winLoss) }}>
                  {decimalInvertedReportFormatter(winLoss, null, true)}
                </span>
              </div>
            </div>
          );
        }}
        getGlobalTotals={(data) => {
          const tickets = new Set(
            data
              .map(item => item.ticket)
              .filter(t => t && t !== "")
          );

          return {
            description: `Total Wagers: ${tickets.size}`,
            totalWagers: tickets.size,
            riskAmount: data.reduce(
              (acc, item) => acc + (item.riskAmount || 0),
              0
            ),
            winAmount: data.reduce(
              (acc, item) => acc + (item.winAmount || 0),
              0
            ),
            resultDetail: data.reduce(
              (acc, item) =>
                acc + (item.resultDetail && !isNaN(item.resultDetail)
                  ? item.resultDetail
                  : 0),
              0
            ),
          };
        }}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="placedDate"
          dataFormat={dateTimeReportFormatter}
        >
          Placed Date / Sport
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="description">
          Complete Description
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="riskAmount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Risk
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="winAmount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Win
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="resultDetail"
          dataFormat={decimalInvertedReportFormatter}
        >
          Neto / Result
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="score">
          User / Score
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="phoneIP">
          Phone / IP
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default WagersOnGameReport;
